<template>
  <el-popover
    placement="top-end"
    width="294"
    trigger="click"
    popper-class="popperclass"
    offset="-15"
  >
    <div class="title">{{title}}</div>
    <div class="list-wrap">
      <div
        class="item"
        v-for="(item,index) in list"
        :key="index"
        @click="handleToEdit(item)"
      >
        <div
          class="point"
          :class="{'point-other':item.status==0}"
        ></div>
        <div class="topic-name">{{item.writing_title}}</div>
      </div>
    </div>
    <div
      class="more-content"
      slot="reference"
    >还有{{list.length-4}}项...</div>
  </el-popover>
</template>

<script>

export default {

  props: {
    list: {
      type: Array,
      default: () => { return [] }
    },
    date:{
       type: Date,
      default: () => { return "" }
    }
  },
  watch:{
date(val){
  if(val){
this.title = this.$moment(val).format("DD")
  }
}
  },
  data() {
    return {
title:"",
    };
  },
  created() {

  },
  computed: {

  },
  methods: {
handleToEdit(item){
this.$emit('edit',item)
}
  }
};
</script>

<style lang="less" scoped>
.popperclass {
  border: solid !important;
  background-color: #fff !important;
}
.title {
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.more-content {
  height: 30px;
  cursor: pointer;
  margin-top: 16px;
  text-align: center;
  color: #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.more-content:hover {
  color: #909399;
  background: #dcdfe6;
}
.list-wrap {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  .item {
    cursor: pointer;
    & + .item {
      margin-top: 16px;
    }
    display: flex;
    align-items: center;

    .point {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #67c23a;
      margin-right: 10px;
    }
    .point-other {
      background: #f56c6c;
    }
    .topic-name {
      width: 100%;
      font-size: 14px;
      color: #606266;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
